import styled from "@emotion/styled";

/**
 * Green "John Deere" badge: something came from John Deere Operations Center
 * (an imported field boundary, an imported combine). Text-only so we don't
 * have to manage Deere logo assets or worry about brand-guideline
 * restrictions. One component so the field list and the device list cannot
 * drift apart.
 */
const JdBadge = styled.span`
  display: inline-flex;
  align-items: center;
  flex-shrink: 0;
  margin-left: 6px;
  padding: 1px 6px;
  font-family: Nunito Sans, sans-serif;
  font-size: 10px;
  font-weight: 700;
  line-height: 14px;
  letter-spacing: 0.4px;
  color: #137333;
  background: #e6f4ea;
  border-radius: 999px;
  white-space: nowrap;
`;

export default JdBadge;
